const main = {
    siteName: 'The West Heaven Hotel',
    home: 'Accueil',
    about: 'A Propos',
    aboutUs: 'A Propos de Nous',
    ourServices : 'Nos Services',
    rooms: 'Chambres',
    room: 'Chambre',
    blog: 'Blog',
    faq: 'FAQs',
    contact: 'Contact',
    contactInfo: 'Info Contact',
    infoNews: 'Actualités',
    newsPromotions: 'Nouveauté & Promotions',
    infoCovid: 'Informations Covid',
    restaurant: 'Restaurant',
    gallery: 'Gallerie',
    posts: 'Articles',
    post: 'Article',
    french: 'Français',
    english: 'English',
    bookNow: 'Réserver',
    menu: 'Menu',
    usefulLinks: 'Liens utiles',
    watchVideo: 'Voir la Vidéo',
    welcome : 'Bienvenue à West Heaven',
    welcomeDescription: 'The West Heaven Hotel - L\'hôtel qu\'il vous faut à Douala, Cameroon.',
    scrollDown : 'En bas',
    airConditioned : 'Air Conditionné',
    allInclusive : 'Tout compris',
    underProtection : 'Sous Protection',
    freeWifi : 'Wifi gratuit',
    aboutTitle1 : "Nous avons +17 années <1 /> d'expériences.",
    aboutDesc1 : "Avec une équipe de professionnels qualifiés et expérimentés, le West Heaven Hotel est là pour vous servir et vous offrir un séjour des plus remarquables. Du restaurant étoilé au snack-bar décontracté, votre satisfaction est garantie.",
    aboutTitle2 : 'Dites oui au confort et au bien être!',
    aboutDesc2 : "Que vous souhaitiez passer un moment agréable et passionnant dans notre restaurant snack-bar ou simplement vous détendre et vous relaxer dans l'une de nos belles chambres, le West Heaven Hotel garantit toujours votre confort et votre satisfaction.",
    chooseRoom : 'Choisir une chambre',
    moreAbout : 'Plus sur nous',
    waitingForYou : "L'Hôtel West Heaven Vous Attend!",
    waitingForYouDesc : "Hôtel sobre, confortable et propre situé à Youpwe à la limite avec bonapriso. L'Hôtel West heaven vous propose divers types de chambres toutes très confortable avec une magnifique vue sur le fleuve. L'hôtel dispose également d'un snack bar restaurant.",
    ourBestRooms : 'Nos Meilleurs Chambres',
    ourBestRoomsDesc : "Toutes nos chambres sont entièrement insonorisées et climatisées et ont une belle vue sur la ville ou le fleuve. Les chambres de l'hôtel West heaven sont prêtes à vous accueillir dans la ville de Douala à Youpwe, bonapriso.",
    allRooms : 'Toutes Nos Chambres',
    readMore : 'Lire plus',
    aroundHotel : "Au tour de l'hôtel",
    services : "Services",
    aroundHotelDesc : "L'hôtel West Heaven est situé à Youpwe, à la frontière avec Bonapriso, dans la ville de Douala. De l'hôtel vous pouvez admirer le fleuve Wouri. Voici quelques services de l'hôtel West Heaven.",
    guestFeedback : 'Commentaires de nos clients',
    guestFeedbackDesc : 'Quelques avis de nos clients pour vous donner un aperçue de qui nous sommes.',
    france : 'France',
    ivoryCoast : "Côte d'Ivoire",
    usa : 'Etats Unis',
    belgium : 'Belgique',
    from : 'De',
    newsletter : "Notre Blog",
    newsletterDesc : "Découvrez les derniers actualités, Nouveautés, Promotions et évènements de l'Hôtel West Heaven à Douala",
    allPublications : 'Tous les Articles',
    allRightReserved : 'Tous droits réservés',
    designWith : 'Designé avec',
    by : 'par',
    aboutOurHotel : "A Propos De l'Hôtel",
    firstDescription : "Situé dans une zone privilégiée à 300m d'un embranchement du fleuve wouri, The West HEAVEN hôtel a été baptisé le Phare de Youpwé. Localité convoitée pour sa capacité halieutique et touristique.",
    searchYourRoom : 'Recherchez votre chambre',
    checkIn : 'Arrivé',
    checkOut : 'Départ',
    person : 'Personne',
    children : 'Enfant',
    searchRoom : 'Chercher une chambre',
    reservation : 'Reservation',
    night : 'nuit',
    guests : 'Invités',
    reviews : 'Avis',
    amenity : 'Aménagements',
    location :  'Localisation',
    similarRooms : 'Chambres Similaires',
    chooseYourRoom : 'Choisir votre Chambre',
    chooseYourRoomDesc : "Les chambres sont classées en 3 catégories, 🥉Chambres Standards , 🥈Chambres Conforts, 🥇Chambres Seniors. C'est avec élégance et professionnalisme que notre équipe sera ravie de vous accueillir 24/7 tout en vous garantissant sécurité et discrétion.",
    standard : 'Standard',
    comfort : 'Confort',
    senior : 'Senior',
    allPhotos : 'Toutes les Photos',
    hotel : 'Hôtel',
    landscape : 'Paysage',
    photoGallery : 'Gallery Photo',
    photoGalleryDesc : "Les images parlent mieux que des mots. Alors jettez un oeil à nôtre gallery photo et vous comprendrez pourquoi faire de l'hôtel West Heaven votre destination préféré",
    getInTouch : 'Prennez Contact',
    getInTouchDesc : "Nous sommes disponible 24h/24 et 7jrs/7 pour répondre à vos question et préoccupations. N’hésitez pas à nous contacter par appel téléphonique, message WhatsApp, e-mail ou en vous rendant directement à l'Hôtel West Heaven.",
    welcomes: 'Bienvenue',
    call : 'Appeler',
    write : 'Écrire',
    ourAddress :  'Marché Youpwé, Douala, Cameroun',
    leaveA : 'Laisser un',
    review : 'avis',
    comment : 'commentaire',
    message : 'message',
    name : 'Nom',
    email : 'E-mail',
    your : 'Votre',
    ici : 'ici',
    send : 'Envoyer',
    wePromise : 'Nous nous engageons à ne pas divulguer vos informations personnelles à des tiers.',
    topManager : 'Directeur général',
    receptionist : 'Receptioniste',
    headChef : 'Chef Cuisinier',
    barman : 'Barman',
    topManagerSpeech : "Chacun aimerait être traité comme chez soi à l'hôtel, et chez soi - comme à l'hôtel. L'hospitalité est une qualité qui se compose de la simplicité primitive et de la grandeur antique.",
    ourTeam : 'Notre Formidable Équipe',
    ourTeamDesc : "L'hôtel West heaven dispose d'une équipe de professionnels qualifiés et expérimentés ayant pour seul et unique mission votre confort et votre bien-être tout au long de votre séjour.",
    whatDoWeOffer :  'Ce Que Nous Vous Offrons',
    whatDoWeOfferDesc :  "D'une capacité de 10 chambres, West Heaven vous offre en plus du service d'Hébergement, La Location de voitures, Le Tourisme, La Restauration (Petit dejeuner, grillade). Découvrez l'entièreté de nos services.",
    carRental : 'Location de voiture',
    freeTelephone : 'Téléphone Gratuit',
    smartTV : 'TV Smart',
    laundry : 'Service de Chambre',
    snackbar : 'Snack-bar',
    yard : 'Jardin de balcon',
    yards : 'Jardins de balcon',
    shower : 'Douche',
    toiletService :  'Service de toilette',
    bidet : 'Bidet',
    soundproofing : 'Insonorisation',
    gardenView : 'Vue sur le jardin',
    desk : 'Bureau',
    wardrobe : 'Penderie',
    balcony : 'Chambre avec balcon',
    breakfast :  'Petit déjeuner',
    riverView : 'Vue sur le fleuve',
    snackView : 'Vue du Restaurant - Snack Bar',
    innerRoom : 'Intérieur de chambre',
    roomDecoration : "décor d'une chambre",
    nightView : "Vue de l'imauble de nuit",
    barView : 'Vue du Snack Bar',
    roastChicken : "Poulet Roti",
    roastChickenDesc : "Du poulet croustillant à la mayonnaise assaisonné. Accompagné des frites de plantains ou de pommes de terre.",
    grilledChicken : 'Poisson braisé',
    grilledChickenDesc : 'Du bar, du capitaine, du top, ou encore du Maquereau. Servi avec des frites de plantain ou des bâtons de manioc',
    grilledPork : 'Porc Braisé',
    grilledPorkDesc : 'Morceaux de porcs bien braisés et assaisonnés pour conserver un goût esquis. Accompagné avec des frites de plantains.',
    suya : 'Suya (Brochette de Viande)',
    suyaDesc : 'Brochettes de Viande de Bœuf assaisonnée communément appelé soya. Elles se mangent accompagné de piment et des condiments',
    whisky :  'Grands Whiskies',
    whiskyDesc : 'Vos Grands Whiskies de marques sont tous disponibles dans notre snack-bar aux meilleur prix locaux.',
    localDrinks : 'Boissons locales',
    localDrinksDesc : 'Toutes les boissons locales sont tous disponibles dans notre snack-bar aux meilleur prix locaux.',
    ourAwesomeMenu : 'Notre Super Menu',
    ourAwesomeMenuDesc : "Some of the delicious dishes you will find at the West Heaven Hotel",
    AllCategories : 'Toutes les Catégories',
    grills : 'Grillades',
    drinks : 'Boisssons',
    here : 'ici',
    iWantToReserve : 'Bonjour,+je+voudrais+reserver+cette+chambre:+',
    IWantToReserveARoomFor : 'Bonjour,+je+voudrais+reserver+une+chambre+pour+',
    persons : '+personnes',
    and : '+et+',
    childrens : '+enfants',
    fromThe : '+du+',
    toThe : '+au+',
    takeAReservation : 'Faites une réservation',
    phoneOrEmail : 'Email ou numéro de téléphone',
    messageSent  : 'Votre message a été envoyé avec succès.<1/> nous vous répondrons dans de bref délais',
    success :  'Succès',

}

export default main